import axios from 'axios';
import { ApiBaseURL, CLIENT_API_APTH, TableAPIURL } from '../environment';
import { getRecoil } from "recoil-nexus";
import { marketCode, authenticate } from '../Recoil-State';
import { getLoginUserRole } from '../config';
const IGNORE_CASE = /^(?:\w+:)\/\//;

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    const MARKETCODE = getRecoil(marketCode);
    const roleCode= getLoginUserRole(MARKETCODE);
    const auth =  getRecoil(authenticate);
    const secrets = auth?.secrets;
    if ( !IGNORE_CASE.test(config.url) ) {
        config.url = `${ApiBaseURL}/${config.url}`;
    }
    config.headers['userId'] = auth.userName;

    if( config.url.indexOf(ApiBaseURL) >=0 || config.url.indexOf(CLIENT_API_APTH) >=0 || config.url.indexOf('generic') >=0  ) {
        config.headers['X-Az-Auth-Token'] =  auth.token;
        config.headers['userName'] = auth.userName;
        if( MARKETCODE ) {
            config.headers['marketCode']= MARKETCODE;
        }
    } else if(config.url.indexOf(TableAPIURL) >=0 ) {
        config.headers['client_id'] = secrets?.fxhub_table_client_id;
        config.headers['client_secret'] = secrets?.fxhub_table_client_secret;
        config.headers['country_code'] = MARKETCODE;
        config.headers['authorization_token'] =  auth.token;
        config.headers['roleCode'] = roleCode;
    }

    else {
        config.headers['client_id'] = secrets?.fxhub_clientid;
        config.headers['client_secret'] = secrets?.fxhub_client_secret;
        config.headers['country_code'] = MARKETCODE;
        config.headers['authorization_token'] =  auth.token;
        config.headers['roleCode'] = roleCode;
    }
    return config;
});

